<script>
  export let closePanel;
  export let data;
  export let imageId;
  import { fly } from "svelte/transition";
</script>

<div
  class="w-100 h-100 bg-custom-yellow absolute top-0 left-0 z-2 pl4 pt4 pr4 pb0 flex flex-column"
  transition:fly={{
    duration: 250,
    x: window.innerWidth,
    opacity: 0.5,
  }}
>
  <div class="flex w-100 items-center mb3">
    <button on:click={closePanel} class="ma0 pa0"
      ><img src="./icones/back.svg" alt="" /></button
    >
    <h2 class="pa0  ma0 ml3">{data.title}</h2>
  </div>

  <!-- Show the logo if needed -->
  {#if data.show_logo}
    <div class="bg-white w-100 pa3 br3 mb2">
      <img src="./logos/logo-01.png" alt="Logo IDHEAP" />
    </div>
  {/if}

  <p class="lh-copy f4 h-100 overflow-scroll pt0 mt0 mb0">
    {@html data.text}
  </p>

  {#if !data.show_logo}
    <div class="gradient w-100 mb4" />
    <img
      class="detail-img absolute bottom-0 left-0"
      src="./all_content/image_{imageId}/{data.info_panel_detail_img}"
      alt=""
    />
  {/if}
</div>

<style>
  p {
    padding-bottom: 240px;
    margin-bottom: 48px;
  }

  .gradient {
    position: absolute;
    pointer-events: none;
    user-select: none;
    bottom: -4px;
    left: 0px;
    height: 240px;
    background: rgb(255, 245, 0);
    background: linear-gradient(
      0deg,
      rgba(255, 245, 0, 1) 0%,
      rgba(255, 245, 0, 0) 100%
    );
  }

  button {
    background: transparent;
    width: 48px;
    height: 48px;
    flex-shrink: 0;
    align-self: flex-end;
  }
  button img {
    width: 48px;
    height: 48px;
  }

  .detail-img {
    width: 100%;
    height: auto;
    pointer-events: none;
  }
</style>
